import ElasticProcessor from '@lib/processors/elastic-processor'
import store from '~/state/store'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
  },
  {
    attribute: 'supplierName',
    label: 'Supplier Name',
    type: 'string',
    icon: 'el-icon-box',
  },
  {
    attribute: 'sku',
    label: 'SKU',
    type: 'string',
    icon: 'el-icon-files',
  },
  {
    attribute: 'brand',
    label: 'Brand',
    type: 'string',
    icon: 'el-icon-data-line',
  },
  {
    attribute: 'name',
    label: 'Product Name',
    type: 'string',
    icon: 'el-icon-goods',
  },
  {
    attribute: 'updatedAt',
    label: 'Last Updated',
    icon: 'el-icon-date',
    type: 'date',
  },
  {
    attribute: 'availability.enabled',
    label: 'Status',
    icon: 'el-icon-circle-check',
    type: 'select',
    values: [
      {
        label: 'Available',
        value: true,
      },
      {
        label: 'Unavailable',
        value: false,
      },
    ],
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 160,
  },
  {
    name: 'supplierName',
    label: 'Supplier Name',
    icon: 'el-icon-box',
    elasticSubField: 'lowercase',
    width: 160,

  },
  {
    name: 'sku',
    label: 'SKU',
    icon: 'el-icon-files',
    elasticSubField: 'lowercase',
    width: 160,

  },
  {
    name: 'brand',
    label: 'Brand',
    icon: 'el-icon-data-line',
    elasticSubField: 'lowercase',
    width: 160,
  },
  {
    name: 'name',
    label: 'Product Name',
    icon: 'el-icon-goods',
    elasticSubField: 'lowercase',
    width: 160,
  },
  {
    name: 'updatedAt',
    label: 'Last Updated',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 160,
  },
  {
    name: 'availability.enabled',
    icon: 'el-icon-circle-check',
    label: 'Status',
    format: 'capital',
    width: 120,
    component: value => ({
      props: {
        styleObj() {
          return value ? { color: '#29d737' } : { color: '#fc1e1e' }
        },
        badge() {
          return value
            ? { name: 'el-icon-check', pos: 'left' }
            : { name: 'el-icon-close', pos: 'left' }
        },
        value() {
          return value ? 'available' : 'unavailable'
        },
      },
    }),
  },
]

export default component => {
  const supplierId = store.getters['me/meSupplierId']

  const params = {
    component,
    index: 'supplier-products',
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }

  if (supplierId) {
    params.staticDataQuery = {
      filters: [
        {
          attribute: 'supplierId',
          comparison: 'eq',
          value: supplierId,
        },
      ],
    }
  }

  return {
    processor: new ElasticProcessor(params),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'supplier-products',
  }
}
